import _ from 'underscore';
import angular from 'angular';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';
import defaultProfilePic from '../../assets/images/placeholder-user.png';

const NOTIFICATION_TYPES = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PUSH: 'PUSH'
};

function TeamStaffEditCtrl($scope, $q, $state, $stateParams, $timeout, venueService, sdkUtils, utilsService, managementUserService, alertService, organizationService, organizationMemberService, formHelpersService, ERROR_MESSAGES, loggerService, organizationPermissionService, sdkPermissionService, permissionService, TRACKING_EVENT_CATEGORIES, analyticsService, notificationSettingService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();
  const currentUser = managementUserService.getCurrentUser();
  const staffMemberId = $stateParams.id;

  _initScope();

  const promises = [
    _getVenues()
  ];

  if ($scope.editMode) {
    promises.push(_getStaffMember());
    promises.push(_getStaffMemberPermissions());
    promises.push(_getNotificationSettings(staffMemberId));
  }
  promises.push(_getPermissionTypes());
  promises.push(_getCurrentUserPermissions());

  $q.all(promises)
    .then(() => {
      if (!$scope.editMode) {
        $scope.staffMemberForm = {
          enable: true
        };
      }

      _mapStaffMemberNotificationSettingState();
    })
    .finally(() => {
      $scope.loading = false;
    });

  $scope.nextSection = function(form, $event) {
    if ($event) $event.preventDefault();
    if (!form) return null;

    $scope.submitted = true;

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return null;
    }

    $scope.currentSection = $scope.sections.PERMISSIONS;

    return null;
  };

  $scope.changeSection = function(section, $event) {
    if ($event) $event.preventDefault();

    $scope.currentSection = section;
  };

  function _initScope() {
    $scope.loading = true;
    $scope.staffMemberForm = {};
    $scope.editMode = staffMemberId ? true : false; //eslint-disable-line
    $scope.saveStaffMember = _saveStaffMember;
    $scope.staffMemberPermissions = [];
    $scope.staffMemberPermissionsByKey = [];
    $scope.currentUserPermissions = [];
    $scope.staffMemberNotificationSettings = [];
    $scope.staffMemberNotificationSettingsByKey = [];
    $scope.notificationSettingDisabled = function(venueId) {
      if (!$scope.staffMember) return true;

      return !_.contains($scope.staffMember.venues, venueId);
    };
    $scope.defaultProfilePic = defaultProfilePic;

    $scope.permissionsForm = {
      permissions: []
    };

    $scope.notificationSettingsForm = {
      notifications: []
    };

    $scope.sections = {
      BASIC: 'BASIC',
      PERMISSIONS: 'PERMISSIONS',
      NOTIFICATIONS: 'NOTIFICATIONS'
    };
    $scope.currentSection = $scope.sections.BASIC;

    $scope.getVenuePermissionTypes = _getVenuePermissionTypes;
    $scope.getOrganizationPermissionTypes = _getOrganizationPermissionTypes;
    $scope.permissionDisabled = _permissionDisabled;

    $scope.notificationSettingTypes = [{
        name: 'Reservation Created External (widgets, promoters)',
        value: 'RESERVATION_CREATED_EXTERNAL',
        description: 'Send me notifications when a reservation is created by external sources (widgets, promoters, etc...).',
        types: [
          NOTIFICATION_TYPES.EMAIL,
          NOTIFICATION_TYPES.SMS,
          NOTIFICATION_TYPES.PUSH
        ]
      }, {
        name: 'Reservation Created Internal (staff)',
        value: 'RESERVATION_CREATED_INTERNAL',
        description: 'Send me notifications when a reservation is created by staff.',
        types: [
          NOTIFICATION_TYPES.EMAIL,
          NOTIFICATION_TYPES.SMS,
          NOTIFICATION_TYPES.PUSH
        ]
      },
      {
        name: 'Reservation Checked In',
        value: 'RESERVATION_CHECKED_IN',
        description: 'Send me notifications when a reservation is checked in.',
        types: [
          NOTIFICATION_TYPES.PUSH
        ]
      },
      {
        name: 'Reservation Cancelled',
        value: 'RESERVATION_CANCELLED',
        description: 'Send me notifications when a reservation is canceled.',
        types: [
          NOTIFICATION_TYPES.EMAIL,
          NOTIFICATION_TYPES.SMS,
          NOTIFICATION_TYPES.PUSH
        ]
      }, {
        name: 'Reservation Request Created',
        value: 'RESERVATION_REQUEST_CREATED',
        description: 'Send me notifications when a customer submits a request for a reservation.',
        types: [
          NOTIFICATION_TYPES.EMAIL,
          NOTIFICATION_TYPES.SMS,
          NOTIFICATION_TYPES.PUSH
        ]
      }, {
        name: 'Payment Link Completed',
        value: 'PAYMENT_LINK_COMPLETED',
        description: 'Send me notifications when a customer completes a payment link.',
        types: [
          NOTIFICATION_TYPES.EMAIL,
          NOTIFICATION_TYPES.SMS,
          NOTIFICATION_TYPES.PUSH
        ]
      }
    ];
  }

  function _getOrganizationPermissionTypes() {
    return permissionService.getOrganizationPermissionTypes();
  }

  function _getNotificationSettings(orgMemberId) {
    return notificationSettingService.listByOrganizationMemberId(orgMemberId)
      .then(notificationSettings => {
        $scope.staffMemberNotificationSettings = notificationSettings;
      });
  }

  function _getVenuePermissionTypes(venueId) {
    return permissionService.getVenuePermissionTypes(venueId);
  }

  /**
   @desc
   Organization
   Can't give out permissions you don't have
   Can't remove permissions you don't have
   Can't remove your own permissions
   Cannot change owner's permissions

   Venue
   Can give out permissions you don't have
   Can remove permissions you don't have
   Can't remove your own permissions
   Cannot change owner's permissions
  */
  function _permissionDisabled(permissionValue, isOrganization) {
    const hasPermission = !!$scope.staffMemberPermissionsByKey[permissionValue];
    const hasAccess = !!$scope.currentUserPermissions[permissionValue];
    const isOwner = $scope.staffMember ? $scope.staffMember.owner : false;
    const isCurrentUser = !!$scope.isCurrentUser;

    // Cannot change owner permissions;
    if (isOwner) {
      return {
        disable: true,
        tooltip: 'You cannot remove permissions from the organization owner.'
      };
    }

    // If is current user and the staff member already has the permission
    if (isCurrentUser && hasPermission) {
      return {
        disable: true,
        tooltip: 'You cannot remove permissions from yourself.'
      };
    }

    // If not current user and has access
    if (!isCurrentUser && hasAccess) {
      return {
        disable: false
      };
    }

    // If is an organization permission and the staff member has that permission already
    if (isOrganization && hasPermission) {
      return {
        disable: true,
        tooltip: 'You cannot remove organization level permissions.'
      };
    }

    // If is an organization permission and the user does not have access
    if (isOrganization && !hasAccess) {
      return {
        disable: true,
        tooltip: 'You cannot add permissions that you do not have.'
      };
    }

    return false;
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'id',
          'nightProId'
        ].join(',')
      })
      .then(venues => {
        $scope.venues = venues;
      })
      .catch(response => _handleError(response, ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_VENUES));
  }

  function _getStaffMember() {
    return organizationMemberService.readByIdAndOrganizationId(staffMemberId, currentUserOrganization.id)
      .then(staffMember => {
        $scope.staffMember = staffMember;
        $scope.isCurrentUser = $scope.staffMember.managementUser === currentUser.id;
        $scope.staffMemberForm = _mapStaffDataToForm();
      })
      .catch(response => {
        if (response && response.status !== 404) {
          _handleError(response, ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_STAFF_BY_ID);
        }
      });
  }

  /**
   * @desc Create or update a staff member
   * @param {Object} form - Angular form object
   * @param {Object} [$event] - Angular event object
   */
  function _saveStaffMember(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;
    $scope.errors = [];

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return null;
    }

    const staffCreateOrUpdateData = _mapChangedFormValuesToApiData(form);

    $scope.savingStaffMember = true;

    let createOrUpdateStaffMemberPromise;

    if ($scope.editMode) {
      createOrUpdateStaffMemberPromise = organizationMemberService.updateByIdAndOrganizationId(staffMemberId, currentUserOrganization.id, staffCreateOrUpdateData);
    } else {
      createOrUpdateStaffMemberPromise = organizationMemberService.createByOrganizationId(currentUserOrganization.id, staffCreateOrUpdateData);
    }

    return createOrUpdateStaffMemberPromise
      .then(staffMember => {
        $scope.staffMember = staffMember;

        alertService.success(`Staff member ${$scope.editMode ? 'updated' : 'created'}`);

        if (!$scope.editMode) {
          _trackStaffMemberCreated();
        }

        return $q.all([
          _addRemoveStaffMemberPermissions(),
          _addRemoveStaffMemberNotificationSettings()
        ]);
      })
      .then(() => {
        return _getCurrentUserPermissions();
      })
      .then(() => {
        $state.go('app.organization.settings.staff');
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        $scope.savingStaffMember = false;
      });
  }

  /**
   * @desc Maps a hash of values to how the API expects the data to be
   */
  function _mapChangedFormValuesToApiData(form) {
    if (!form) return null;

    let changedValues;
    const staffData = {};

    if (!$scope.editMode) {
      changedValues = angular.copy($scope.staffMemberForm);
    } else {
      changedValues = formHelpersService.getChangedFormValues(form);
    }

    if ('firstName' in changedValues) staffData.firstName = changedValues.firstName;
    if ('lastName' in changedValues) staffData.lastName = changedValues.lastName;
    if ('email' in changedValues) staffData.email = changedValues.email;
    if ('phone' in changedValues) staffData.phone = changedValues.phone ? changedValues.phone.toString() : null;
    if ('title' in changedValues) staffData.title = changedValues.title ? changedValues.title.toString() : null;
    if ('profileImage' in changedValues) staffData.profileImage = changedValues.profileImage;
    if ('enable' in changedValues) staffData.enable = changedValues.enable;

    return staffData;
  }

  /**
   * @desc Maps the $scope.venue to an object the UI will bind to
   * @return Object
   */
  function _mapStaffDataToForm() {
    let staffEditData = {};

    staffEditData = angular.copy($scope.staffMember);

    if (staffEditData.phone) staffEditData.phone = parseInt(staffEditData.phone, 10);

    return staffEditData;
  }

  /**
   * @return {Promise}
   */
  function _addRemoveStaffMemberPermissions() {
    const dataPromises = [];

    for (let key in $scope.permissionsForm.permissions) { //eslint-disable-line
      if (key) {
        const promise = _addRemoveStaffMemberPermission(key, $scope.permissionsForm.permissions[key]);

        if (promise) dataPromises.push(promise);
      }
    }

    return $q.all(dataPromises);
  }

  /**
   * @param {String} permissionName
   * @param {Boolean} [add]
   * @return {Promise|null}
   */
  function _addRemoveStaffMemberPermission(permissionName, add) {
    if (!permissionName) throw new Error('teamStaffEditCtrl - _addRemoveStaffMemberPermission() - permissionName is required');

    const comparator = {};

    //TODO Added for IE support replace with _.includes when lodash replaces underscore
    if (permissionName.indexOf('-') >= 0) {
      const parts = permissionName.split('-');

      comparator.venue = parts[0];
      comparator.value = parts[1];
    } else {
      comparator.value = permissionName;
    }

    const existingPermission = _.findWhere($scope.staffMemberPermissions, comparator);
    if (existingPermission && add) return null; //noop since the permission already exists and we're trying to add it again
    else if (!existingPermission && !add) return null;

    const addOrRemovePermissionPromise = existingPermission ?
      organizationPermissionService.deleteByOrganizationIdAndPermissionId(currentUserOrganization.id, existingPermission.id) :
      organizationPermissionService.createByOrganizationMemberId(currentUserOrganization.id, $scope.staffMember.id, {
        venueId: comparator.venue,
        permission: comparator.value
      });

    return addOrRemovePermissionPromise
      .then(permission => {
        if (existingPermission) {
          $scope.staffMemberPermissions.splice($scope.staffMemberPermissions.indexOf(existingPermission), 1);
        } else {
          $scope.staffMemberPermissions.push(permission);
        }
      });
  }

  /**
   * @return {Promise}
   */
  function _addRemoveStaffMemberNotificationSettings() {
    const dataPromises = [];

    const notificationSettingsByVenueAndType = {};
    const notificationSettings = [];

    for (let key in $scope.notificationSettingsForm.notifications) { //eslint-disable-line
      if (key) {
        const parts = key.split('-');

        if (parts.length === 3) {
          const venueId = parts[0];
          const type = parts[1];
          const notificationType = parts[2];

          const settings = notificationSettingsByVenueAndType[`${venueId}-${type}`] || {};

          settings[notificationType] = $scope.notificationSettingsForm.notifications[key];

          notificationSettingsByVenueAndType[`${venueId}-${type}`] = settings;
        }
      }
    }

    for (let key in notificationSettingsByVenueAndType) { //eslint-disable-line
      if (key) {
        const parts = key.split('-');

        if (parts.length === 2) {
          notificationSettings.push({
            venueId: parts[0],
            type: parts[1],
            notifications: notificationSettingsByVenueAndType[key]
          });
        }
      }
    }

    notificationSettings.forEach(notificationSetting => {
      dataPromises.push(_addOrUpdateStaffMemberNotificationSetting(notificationSetting));
    });

    return $q.all(dataPromises);
  }

  /**
   * @param {Object} notificationSetting
   * @return {Promise|null}
   */
  function _addOrUpdateStaffMemberNotificationSetting(notificationSetting) {
    if (!notificationSetting) throw new Error('teamStaffEditCtrl - _addStaffMemberNotificationSetting() - permissionName is required');

    const existingNotificationSetting = _.findWhere($scope.staffMemberNotificationSettings, {
      venue: notificationSetting.venueId,
      type: notificationSetting.type
    });

    if (existingNotificationSetting) _.extend(existingNotificationSetting, notificationSetting);

    const addOrRemoveNotificationSettingPromise = existingNotificationSetting ?
      notificationSettingService.updateByIdAndByOrganizationMemberId(existingNotificationSetting.id, $scope.staffMember.id, {
        notifications: existingNotificationSetting.notifications
      }) :
      notificationSettingService.createByOrganizationMemberId($scope.staffMember.id, notificationSetting);

    return addOrRemoveNotificationSettingPromise
      .then(permission => {
        if (existingNotificationSetting) {
          $scope.staffMemberNotificationSettings.splice($scope.staffMemberNotificationSettings.indexOf(existingNotificationSetting), 1);
        } else {
          $scope.staffMemberNotificationSettings.push(permission);
        }
      });
  }

  /**
   * @return {Promise}
   */
  function _getStaffMemberPermissions() {
    return organizationPermissionService.listByOrganizationMemberId(currentUserOrganization.id, staffMemberId)
      .then(permissions => {
        $scope.staffMemberPermissions = permissions;
      })
      .then(_mapStaffMemberPermissionsState)
      .catch(response => _handleError(response, ERROR_MESSAGES.ERROR_GETTING_PERMISSIONS));
  }

  function _mapStaffMemberPermissionsState() {
    _.each($scope.staffMemberPermissions, staffPermission => { //eslint-disable-line
      const permissionKey = staffPermission.venue ? (`${staffPermission.venue}-${staffPermission.value}`) : staffPermission.value;
      $scope.staffMemberPermissionsByKey[permissionKey] = true;
      $scope.permissionsForm.permissions[permissionKey] = true;
    });
  }

  function _mapStaffMemberNotificationSettingState() {
    _.each($scope.staffMemberNotificationSettings, notificationSetting => {
      for (let key in notificationSetting.notifications) { //eslint-disable-line
        const notificationSettingKey = `${notificationSetting.venue}-${notificationSetting.type}-${key}`;
        if (notificationSetting.notifications[key]) {
          $scope.staffMemberNotificationSettingsByKey[notificationSettingKey] = true;
          $scope.notificationSettingsForm.notifications[notificationSettingKey] = true;
        }
      }
    });
  }

  function _getPermissionTypes() {
    return sdkPermissionService.list()
      .then(permissions => permissionService.setPermissionTypes(permissions))
      .catch(response => _handleError(response, ERROR_MESSAGES.ERROR_GETTING_PERMISSIONS));
  }

  function _getCurrentUserPermissions() {
    return organizationPermissionService.listByManagementUserId(currentUser.id)
      .then(permissions => {
        permissionService.setCurrentPermissions(permissions);

        _.each(permissions, userPermission => {
          const permissionKey = userPermission.venue ? (`${userPermission.venue}-${userPermission.value}`) : userPermission.value;
          $scope.currentUserPermissions[permissionKey] = true;
        });
      });
  }

  function _handleError(response, type) {
    const errorMsg = sdkUtils.getErrorFromResponse(response);
    if (errorMsg) loggerService.error(errorMsg);
    alertService.fatalError(type);
  }

  function _trackStaffMemberCreated() {
    analyticsService.trackEvent(SEGMENT_TRACKING_EVENTS.CREATED_STAFF_MEMBER, {
      category: TRACKING_EVENT_CATEGORIES.STAFF_MEMBERS
    });
  }
}

TeamStaffEditCtrl.$inject = [
  '$scope',
  '$q',
  '$state',
  '$stateParams',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.utils',
  'utilsService',
  'jsSdk.managementUser',
  'alertService',
  'organizationService',
  'jsSdk.organizationMember',
  'formHelpersService',
  'ERROR_MESSAGES',
  'loggerService',
  'jsSdk.organizationPermission',
  'jsSdk.permission',
  'permissionService',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService',
  'jsSdk.notificationSetting'
];

export default TeamStaffEditCtrl;



// WEBPACK FOOTER //
// ./src/components/teamStaffEdit/teamStaffEditCtrl.js